// extracted by mini-css-extract-plugin
export default {"heading":"lC-z","corrected":"mC-z","redirectVerbiageContainer":"nC-z","redirectVerbiageText":"oC-z"};